/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const UsersDocument = gql`
    query Users($limiit: Int, $search: String) {
  users(limit: $limiit, search: $search) {
    id
    email
    activePremium
    userBlock {
      id
      status
      comment
      createdAt
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      limiit: // value for 'limiit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UsersWithPaginationDocument = gql`
    query UsersWithPagination($search: String, $page: Int, $limit: Int) {
  usersWithPagination(search: $search, page: $page, limit: $limit) {
    users {
      id
      email
      activePremium
      userPremium {
        id
        userPremiumEndDate
        userPremiumType
      }
      userBlock {
        status
        comment
      }
      userDispute {
        id
        path
      }
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useUsersWithPaginationQuery__
 *
 * To run a query within a React component, call `useUsersWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsersWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>(UsersWithPaginationDocument, options);
      }
export function useUsersWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>(UsersWithPaginationDocument, options);
        }
// @ts-ignore
export function useUsersWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>;
export function useUsersWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<UsersWithPaginationQuery | undefined, UsersWithPaginationQueryVariables>;
export function useUsersWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>(UsersWithPaginationDocument, options);
        }
export type UsersWithPaginationQueryHookResult = ReturnType<typeof useUsersWithPaginationQuery>;
export type UsersWithPaginationLazyQueryHookResult = ReturnType<typeof useUsersWithPaginationLazyQuery>;
export type UsersWithPaginationSuspenseQueryHookResult = ReturnType<typeof useUsersWithPaginationSuspenseQuery>;
export type UsersWithPaginationQueryResult = Apollo.QueryResult<UsersWithPaginationQuery, UsersWithPaginationQueryVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($userId: Int!, $password: String!) {
  changeUserPassword(userId: $userId, password: $password) {
    id
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const SetRegimeImpersonateDocument = gql`
    mutation SetRegimeImpersonate($userId: Int!) {
  setRegimeImpersonate(userId: $userId) {
    id
  }
}
    `;
export type SetRegimeImpersonateMutationFn = Apollo.MutationFunction<SetRegimeImpersonateMutation, SetRegimeImpersonateMutationVariables>;

/**
 * __useSetRegimeImpersonateMutation__
 *
 * To run a mutation, you first call `useSetRegimeImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRegimeImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRegimeImpersonateMutation, { data, loading, error }] = useSetRegimeImpersonateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetRegimeImpersonateMutation(baseOptions?: Apollo.MutationHookOptions<SetRegimeImpersonateMutation, SetRegimeImpersonateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRegimeImpersonateMutation, SetRegimeImpersonateMutationVariables>(SetRegimeImpersonateDocument, options);
      }
export type SetRegimeImpersonateMutationHookResult = ReturnType<typeof useSetRegimeImpersonateMutation>;
export type SetRegimeImpersonateMutationResult = Apollo.MutationResult<SetRegimeImpersonateMutation>;
export type SetRegimeImpersonateMutationOptions = Apollo.BaseMutationOptions<SetRegimeImpersonateMutation, SetRegimeImpersonateMutationVariables>;
export const ExitRegimeImpersonateDocument = gql`
    mutation ExitRegimeImpersonate {
  exitRegimeImpersonate
}
    `;
export type ExitRegimeImpersonateMutationFn = Apollo.MutationFunction<ExitRegimeImpersonateMutation, ExitRegimeImpersonateMutationVariables>;

/**
 * __useExitRegimeImpersonateMutation__
 *
 * To run a mutation, you first call `useExitRegimeImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExitRegimeImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exitRegimeImpersonateMutation, { data, loading, error }] = useExitRegimeImpersonateMutation({
 *   variables: {
 *   },
 * });
 */
export function useExitRegimeImpersonateMutation(baseOptions?: Apollo.MutationHookOptions<ExitRegimeImpersonateMutation, ExitRegimeImpersonateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExitRegimeImpersonateMutation, ExitRegimeImpersonateMutationVariables>(ExitRegimeImpersonateDocument, options);
      }
export type ExitRegimeImpersonateMutationHookResult = ReturnType<typeof useExitRegimeImpersonateMutation>;
export type ExitRegimeImpersonateMutationResult = Apollo.MutationResult<ExitRegimeImpersonateMutation>;
export type ExitRegimeImpersonateMutationOptions = Apollo.BaseMutationOptions<ExitRegimeImpersonateMutation, ExitRegimeImpersonateMutationVariables>;
export const UserChangePremiumDocument = gql`
    mutation UserChangePremium($userId: Int!, $endDate: String!, $type: String!) {
  userChangePremium(userId: $userId, endDate: $endDate, type: $type) {
    id
    email
  }
}
    `;
export type UserChangePremiumMutationFn = Apollo.MutationFunction<UserChangePremiumMutation, UserChangePremiumMutationVariables>;

/**
 * __useUserChangePremiumMutation__
 *
 * To run a mutation, you first call `useUserChangePremiumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangePremiumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangePremiumMutation, { data, loading, error }] = useUserChangePremiumMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      endDate: // value for 'endDate'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserChangePremiumMutation(baseOptions?: Apollo.MutationHookOptions<UserChangePremiumMutation, UserChangePremiumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangePremiumMutation, UserChangePremiumMutationVariables>(UserChangePremiumDocument, options);
      }
export type UserChangePremiumMutationHookResult = ReturnType<typeof useUserChangePremiumMutation>;
export type UserChangePremiumMutationResult = Apollo.MutationResult<UserChangePremiumMutation>;
export type UserChangePremiumMutationOptions = Apollo.BaseMutationOptions<UserChangePremiumMutation, UserChangePremiumMutationVariables>;
export const UserDeletePremiumDocument = gql`
    mutation UserDeletePremium($userId: Int!) {
  userDeletePremium(userId: $userId) {
    id
    email
  }
}
    `;
export type UserDeletePremiumMutationFn = Apollo.MutationFunction<UserDeletePremiumMutation, UserDeletePremiumMutationVariables>;

/**
 * __useUserDeletePremiumMutation__
 *
 * To run a mutation, you first call `useUserDeletePremiumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeletePremiumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeletePremiumMutation, { data, loading, error }] = useUserDeletePremiumMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeletePremiumMutation(baseOptions?: Apollo.MutationHookOptions<UserDeletePremiumMutation, UserDeletePremiumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeletePremiumMutation, UserDeletePremiumMutationVariables>(UserDeletePremiumDocument, options);
      }
export type UserDeletePremiumMutationHookResult = ReturnType<typeof useUserDeletePremiumMutation>;
export type UserDeletePremiumMutationResult = Apollo.MutationResult<UserDeletePremiumMutation>;
export type UserDeletePremiumMutationOptions = Apollo.BaseMutationOptions<UserDeletePremiumMutation, UserDeletePremiumMutationVariables>;
export const GenerateDisputeDocument = gql`
    mutation GenerateDispute($userId: Int!) {
  generateDispute(userId: $userId)
}
    `;
export type GenerateDisputeMutationFn = Apollo.MutationFunction<GenerateDisputeMutation, GenerateDisputeMutationVariables>;

/**
 * __useGenerateDisputeMutation__
 *
 * To run a mutation, you first call `useGenerateDisputeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDisputeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDisputeMutation, { data, loading, error }] = useGenerateDisputeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateDisputeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDisputeMutation, GenerateDisputeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDisputeMutation, GenerateDisputeMutationVariables>(GenerateDisputeDocument, options);
      }
export type GenerateDisputeMutationHookResult = ReturnType<typeof useGenerateDisputeMutation>;
export type GenerateDisputeMutationResult = Apollo.MutationResult<GenerateDisputeMutation>;
export type GenerateDisputeMutationOptions = Apollo.BaseMutationOptions<GenerateDisputeMutation, GenerateDisputeMutationVariables>;
export type UsersQueryVariables = Types.Exact<{
  limiit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'GraphUser', id?: number | null, email?: string | null, activePremium: boolean, userBlock?: { __typename?: 'GraphUserBlock', id?: number | null, status?: boolean | null, comment?: string | null, createdAt?: any | null } | null }> };

export type UsersWithPaginationQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UsersWithPaginationQuery = { __typename?: 'Query', usersWithPagination: { __typename?: 'GraphUserPaginator', users: Array<{ __typename?: 'GraphUser', id?: number | null, email?: string | null, activePremium: boolean, userPremium?: { __typename?: 'GraphUserPremium', id?: number | null, userPremiumEndDate?: any | null, userPremiumType?: string | null } | null, userBlock?: { __typename?: 'GraphUserBlock', status?: boolean | null, comment?: string | null } | null, userDispute?: { __typename?: 'GraphDispute', id?: number | null, path: string } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type ChangeUserPasswordMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type ChangeUserPasswordMutation = { __typename?: 'Mutation', changeUserPassword: { __typename?: 'GraphUser', id?: number | null } };

export type SetRegimeImpersonateMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type SetRegimeImpersonateMutation = { __typename?: 'Mutation', setRegimeImpersonate: { __typename?: 'GraphUser', id?: number | null } };

export type ExitRegimeImpersonateMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ExitRegimeImpersonateMutation = { __typename?: 'Mutation', exitRegimeImpersonate: boolean };

export type UserChangePremiumMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  endDate: Types.Scalars['String']['input'];
  type: Types.Scalars['String']['input'];
}>;


export type UserChangePremiumMutation = { __typename?: 'Mutation', userChangePremium: { __typename?: 'GraphUser', id?: number | null, email?: string | null } };

export type UserDeletePremiumMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type UserDeletePremiumMutation = { __typename?: 'Mutation', userDeletePremium: { __typename?: 'GraphUser', id?: number | null, email?: string | null } };

export type GenerateDisputeMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type GenerateDisputeMutation = { __typename?: 'Mutation', generateDispute: string };
